(() => {
  const testId = "DLT-013";
  let cached = null;

  const $  = (s, r=document) => r.querySelector(s);

  // ---------- Handle helpers ----------
  function currentHandle() {
    return decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/)||[,''])[1]||'').toLowerCase();
  }
  function domHandle() {
    return (document.querySelector('[data-product-handle]')?.getAttribute('data-product-handle')||'').toLowerCase();
  }

  // ---------- Personalize exclusions ONLY (sticky still builds) ----------
  const PERSONALIZE_EXCLUDES = new Set([]);
  function shouldShowPersonalize() {
    const h = currentHandle() || domHandle();
    return !PERSONALIZE_EXCLUDES.has(h);
  }

  // ---------- Jack Sack helpers ----------
  function isJackSackProduct() {
    const h = currentHandle() || domHandle();
    if (h.includes('jack-sack')) return true;

    const titleText  = (document.querySelector('.product__title,[data-product-title],h1.product-title')?.textContent || '').toLowerCase();
    const vendorText = (document.querySelector('.product__vendor,[data-product-vendor]')?.textContent || '').toLowerCase();
    return (titleText.includes('jack') && titleText.includes('sack')) || vendorText.includes('jack sack');
  }

  // Replace "Additional R..." → "Additional cost" for Jack Sack
  function normalizePersonalizeCopyForJackSack(text) {
    if (!isJackSackProduct()) return text;
    text = text.replace(/\bAdditional\s*R\s*\d+(?:[\.,]\d{2})?\b/gi, 'Additional cost');
    text = text.replace(/\bAdditional\s*R\b/gi, 'Additional cost');
    text = text.replace(/\(\s*Additional cost\s*\)/gi, '(Additional cost)');
    return text;
  }

  // ---------- Cache product bits (robust selectors) ----------
  function getCached() {
    if (!cached) {
      cached = {
        productTitle:
          $(".product__title") ||
          $("[data-product-title]") ||
          $("h1.product-title"),
        /** NOTE: we’ll re-find the live price dynamically — this is just a first hit */
        priceElement:
          $("[data-button-price]") ||
          $(".product__price .money, .price .money, .price__current .money, .price-item--sale, .price-item--regular") ||
          null,
        quantityWrapper:
          $(".quantity__wrapper") ||
          $(".product-form__quantity") ||
          $("[data-quantity-selector]") ||
          $(".quantity-selector"),
        atcInForm:
          $("form[action*='/cart/add'] button[type='submit']") ||
          $("button[name='add'], .product-form__submit, [data-product-atc], .product__submit, .product__buttons button[type='submit']")
      };
    }
    return cached;
  }

  function built() { return !!document.querySelector(`.${testId}-sticky-container`); }

  // ---------- Helpers: robust live price lookup ----------
  function getLivePriceEl() {
    // Prefer explicit theme hooks if present
    const cand =
      document.querySelector("[data-button-price]") ||
      document.querySelector(".price__current .money") ||
      document.querySelector(".price-item--sale") ||
      document.querySelector(".price .money") ||
      document.querySelector(".product__price .money") ||
      document.querySelector(".price-item--regular") ||
      null;

    // Some themes fully swap containers; ensure we return the visible one
    if (!cand) return null;
    const isHidden = (el) => el && (el.offsetParent === null || window.getComputedStyle(el).display === "none" || window.getComputedStyle(el).visibility === "hidden");
    if (cand.matches(".price-item--regular, .price-item--sale")) {
      // If sale present & visible, prefer it
      const sale = document.querySelector(".price-item--sale");
      if (sale && !isHidden(sale)) return sale;
      const reg = document.querySelector(".price-item--regular");
      if (reg && !isHidden(reg)) return reg;
    }
    return cand;
  }

  function getLivePriceText() {
    const el = getLivePriceEl();
    if (!el) return "";
    // Grab the most “money-like” sub-element first
    const money = el.querySelector?.(".money, .price__current, .price-item--sale, .price-item--regular");
    const node = money || el;
    return (node.textContent || "").trim();
  }

  function setStickyPrice(text) {
    const stickyPriceEl = document.querySelector("[data-sticky-price]");
    if (stickyPriceEl && text) stickyPriceEl.textContent = text;
  }

  function updateStickyPriceNow() {
    setStickyPrice(getLivePriceText());
  }

  // ---------- Sticky builder ----------
  function createSticky(originalStickyArea) {
    if (built()) return;

    const { productTitle, priceElement, quantityWrapper, atcInForm } = getCached();
    const nativeATC = originalStickyArea?.querySelector(".DLT-002-sticky-buttons-add-to-cart") || atcInForm;

    const c = document.createElement("div");
    c.className = `${testId}-sticky-container`;

    const top = document.createElement("div");
    top.className = `${testId}-top-row`;

    if (productTitle) {
      const t = document.createElement("div");
      t.className = `${testId}-product-title`;
      t.textContent = productTitle.textContent.trim();
      top.appendChild(t);
    }

    const p = document.createElement("div");
    p.className = `${testId}-product-price`;
    p.setAttribute("data-sticky-price","");
    p.textContent = (getLivePriceText() || priceElement?.textContent || "").trim();
    top.appendChild(p);

    const bottom = document.createElement("div");
    bottom.className = `${testId}-bottom-row`;
    if (quantityWrapper) bottom.appendChild(createQty(quantityWrapper));
    if (nativeATC)     bottom.appendChild(createATC(nativeATC));

    c.append(top, bottom);
    document.body.appendChild(c);
  }

  // ---------- Qty control ----------
  function createQty(origWrap) {
    const wrap  = document.createElement("div");
    wrap.className = `${testId}-quantity-wrapper`;

    const minus = document.createElement("button");
    minus.className = `${testId}-quantity-button ${testId}-quantity-button--minus`;
    minus.type = "button"; minus.textContent = "−";

    const input = document.createElement("input");
    input.className = `${testId}-quantity-input`;
    input.type = "number"; input.min = "1";
    const oIn = origWrap?.querySelector("[data-quantity-input], input[type='number']");
    input.value = (oIn?.value || "1").toString();

    const plus  = document.createElement("button");
    plus.className = `${testId}-quantity-button ${testId}-quantity-button--plus`;
    plus.type = "button"; plus.textContent = "+";

    wrap.append(minus, input, plus);
    if (oIn) syncQty(wrap, origWrap);
    return wrap;
  }

  // ---------- ATC button ----------
  function createATC(origBtn) {
    const btn = document.createElement("button");
    btn.className = `${testId}-add-to-cart-button`;
    btn.type = "button";
    const span = origBtn?.querySelector?.("[data-add-to-cart-text]");
    btn.textContent = (span ? span.textContent : origBtn?.textContent || "Add to Cart").trim();
    btn.addEventListener("click", (e) => { e.preventDefault(); origBtn?.click?.(); });
    return btn;
  }

  // ---------- Personalize support (any app) ----------
  function findPersonalizerButton() {
    return document.querySelector(".donkey-personaliser__watcher");
  }

  function createPersonalizeButton(origBtn) {
    const b = document.createElement("button");
    b.className = `${testId}-personalize-button`;
    b.type = "button";

    const raw = (origBtn.textContent || "Personalise It").trim();
    const label = normalizePersonalizeCopyForJackSack(raw);
    b.textContent = label;

    b.addEventListener("click", (e) => { e.preventDefault(); origBtn.click(); });
    return b;
  }

  function insertPersonalizeIfPresent() {
    const sticky = document.querySelector(`.${testId}-sticky-container`);
    const bottom = sticky?.querySelector(`.${testId}-bottom-row`);
    if (!sticky || !bottom) return;

    if (!shouldShowPersonalize()) {
      const existing = sticky.querySelector(`.${testId}-middle-row`);
      if (existing) existing.remove();
      sticky.classList.remove(`${testId}-sticky-container--with-personalization`);
      return;
    }

    if (sticky.querySelector(`.${testId}-middle-row`)) return;

    const origBtn = findPersonalizerButton();
    if (!origBtn) return;

    sticky.classList.add(`${testId}-sticky-container--with-personalization`);
    const middle = document.createElement("div");
    middle.className = `${testId}-middle-row`;
    middle.appendChild(createPersonalizeButton(origBtn));
    sticky.insertBefore(middle, bottom);
  }

  // ---------- Sync qty + live price ----------
  function syncQty(customWrap, origWrap) {
    const cIn  = customWrap.querySelector(`.${testId}-quantity-input`);
    const cDec = customWrap.querySelector(`.${testId}-quantity-button--minus`);
    const cInc = customWrap.querySelector(`.${testId}-quantity-button--plus`);
    const oIn  = origWrap.querySelector("[data-quantity-input], input[type='number']");

    if (!cIn || !oIn) return;

    cDec.addEventListener("click", (e) => {
      e.preventDefault();
      const v = Math.max(1, (parseInt(oIn.value,10) || 1) - 1);
      oIn.value = v; cIn.value = v;
      oIn.dispatchEvent(new Event("change", { bubbles: true }));
      updateStickyPriceNow();
    });

    cInc.addEventListener("click", (e) => {
      e.preventDefault();
      const v = (parseInt(oIn.value,10) || 1) + 1;
      oIn.value = v; cIn.value = v;
      oIn.dispatchEvent(new Event("change", { bubbles: true }));
      updateStickyPriceNow();
    });

    cIn.addEventListener("change", () => {
      const v = Math.max(1, parseInt(cIn.value,10) || 1);
      oIn.value = v;
      oIn.dispatchEvent(new Event("change", { bubbles: true }));
      updateStickyPriceNow();
    });

    oIn.addEventListener("change", () => {
      cIn.value = oIn.value;
      updateStickyPriceNow();
    });

    // initial
    updateStickyPriceNow();
  }

  // ---------- Robust, persistent price syncing ----------
  function setupLivePriceSync() {
    // 1) Listen to common variant-change events/hooks
    const variantSelectors = [
      'select[name="id"]',
      'select[name*="variant"]',
      '.single-option-selector',
      '[data-product-variant-id]'
    ];

    document.addEventListener("change", (e) => {
      if (variantSelectors.some(sel => e.target.matches?.(sel))) {
        updateStickyPriceNow();
      }
    }, true);

    // Many themes fire custom events on variant change
    window.addEventListener("variant:change", updateStickyPriceNow, true);
    document.addEventListener("variant:change", updateStickyPriceNow, true);
    document.addEventListener("product:variant-change", updateStickyPriceNow, true);
    document.addEventListener("theme:product:change", updateStickyPriceNow, true);

    // 2) Observe the price container for node swaps / text changes
    const priceContainers = [
      ".price", ".product__price", ".price__current", ".product__info-wrapper", "[data-product-price]"
    ];
    const attachObserver = (root) => {
      priceContainers.forEach(sel => {
        const el = root.querySelector(sel);
        if (!el || el.__dlt013Observed) return;
        const mo = new MutationObserver(() => updateStickyPriceNow());
        mo.observe(el, { childList: true, characterData: true, subtree: true });
        el.__dlt013Observed = true;
      });
    };
    attachObserver(document);

    const moRoot = new MutationObserver((muts) => {
      // If theme swaps price blocks entirely, re-attach
      muts.some(() => { attachObserver(document); return false; });
    });
    moRoot.observe(document.body, { childList: true, subtree: true });

    // 3) Gentle polling fallback (covers async price appends, currency conversions, etc.)
    let lastText = "";
    const poll = setInterval(() => {
      const t = getLivePriceText();
      if (t && t !== lastText) {
        setStickyPrice(t);
        lastText = t;
      }
    }, 800);

    // Prime it
    updateStickyPriceNow();
  }

  // ---------- Sticky show/hide based on sections ----------
  function setupStickyVisibility() {
    const sticky = document.querySelector(`.${testId}-sticky-container`);
    if (!sticky) return;

    let isHidden = false;
    function setStickyVisible(show) {
      if (show && isHidden) {
        sticky.style.opacity = "1";
        sticky.style.pointerEvents = "auto";
        isHidden = false;
      } else if (!show && !isHidden) {
        sticky.style.opacity = "0";
        sticky.style.pointerEvents = "none";
        isHidden = true;
      }
    }

    let buttonsInView = false;
    let imageInView   = false;

    function recompute() {
      if (buttonsInView) return setStickyVisible(false);
      if (imageInView)   return setStickyVisible(true);
      setStickyVisible(true);
    }

    const threshold = [0.05];
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        const el = e.target;
        if (el.matches(".product__block__buttons")) {
          buttonsInView = e.isIntersecting;
        } else if (el.matches(".product__block__image.product__block__image--center")) {
          imageInView = e.isIntersecting;
        }
      }
      recompute();
    }, { threshold });

    const btnsNow   = document.querySelector(".product__block__buttons");
    const imgCtrNow = document.querySelector(".product__block__image.product__block__image--center");
    if (btnsNow)   io.observe(btnsNow);
    if (imgCtrNow) io.observe(imgCtrNow);

    const mo = new MutationObserver(() => {
      const btns   = document.querySelector(".product__block__buttons");
      const imgCtr = document.querySelector(".product__block__image.product__block__image--center");
      if (btns && !btns.__observedByDLT013) {
        io.observe(btns);
        btns.__observedByDLT013 = true;
      }
      if (imgCtr && !imgCtr.__observedByDLT013) {
        io.observe(imgCtr);
        imgCtr.__observedByDLT013 = true;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    recompute();
    // keep observers; no auto-disconnect
  }

  // ---------- Boot (robust to lazy/async sections) ----------
  function productDomPresent() {
    return document.querySelector('.product__title,[data-product-title],h1.product-title, form[action*="/cart/add"]');
  }

  function init() {
    document.documentElement.classList.add('DLT-013_var_1');

    const themeSticky = document.querySelector(".DLT-002-sticky-buttons");
    createSticky(themeSticky);

    // Live price sync (NEW & persistent)
    setupLivePriceSync();

    // Visibility behavior
    setupStickyVisibility();

    // Personalizer watcher
    const mo = new MutationObserver(insertPersonalizeIfPresent);
    mo.observe(document.body, { childList: true, subtree: true });
    insertPersonalizeIfPresent();
    setTimeout(() => { try { mo.disconnect(); } catch(_){} }, 30000);

    // Lightweight polling for personalizer presence as well
    let tries = 0;
    const poll = setInterval(() => {
      insertPersonalizeIfPresent();
      if (++tries >= 60) clearInterval(poll);
    }, 500);
  }

  function bootstrap(attempt = 0) {
    if (!productDomPresent()) {
      if (attempt < 20) return setTimeout(() => bootstrap(attempt+1), 150);
    }
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bootstrap(), { once: true });
  } else {
    bootstrap();
  }
})();

// SECOND BUTTON — Inline Personalizer label fix (Jack Sack only)
(() => {
  if (!/\/products\/the-jack-sack(?:\/|$)/i.test(location.pathname)) return;

  const SELECTOR = 'button.pplr-c-button.ptc_button, a.pplr-c-button.ptc_button';
  const isSticky = el => el.closest('.DLT-013-sticky-container, .DLT-002-sticky-buttons');

  function patch(root = document) {
    root.querySelectorAll(SELECTOR).forEach(el => {
      if (isSticky(el)) return; // do not touch sticky CTA
      const before = (el.textContent || '').trim();
      const after = before.replace(/\bAdditional\s*R\s*300(\.00)?\b/i, 'Additional cost');
      if (after !== before) el.textContent = after;
    });
  }

  patch();
  const mo = new MutationObserver(() => patch());
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  setTimeout(() => { try { mo.disconnect(); } catch {} }, 30000);
})();

